import React from 'react';
import { COMPANY_NAME_CN, COMPANY_NAME_EN } from './constants';
import { useLanguage } from './i18n/LanguageContext';

export const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-black border-t border-gray-900 text-white py-12">
      <div className="container mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center">
        <div className="flex space-x-8 text-sm text-gray-500">
          <p className="text-sm">{COMPANY_NAME_CN}</p>
        </div>
        <div className="flex space-x-8 text-sm text-gray-500 justify-center">
          <p className="text-sm">{t.footer.contact}</p>
        </div>
        <div className="flex space-x-8 text-sm text-gray-500 justify-end">
          <p className="text-sm">{new Date().getFullYear()} {COMPANY_NAME_EN}. {t.footer.rights}. 
            <a href="https://beian.miit.gov.cn/" target="_blank" className="ml-2">{t.footer.icp}</a>
          </p>
        </div>
      </div>
    </footer>
  );
};
